import { BannerSearchDto } from './dto/banner-search.dto';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { Injectable } from '@angular/core';
import { BannerDto } from './dto/banner.dto';

@Injectable({
  providedIn: 'root',
})
export class BannerAdService {
  constructor(private _apiService: ApiService) {}

  public get(id: number): Promise<BannerDto> {
    return this._apiService.get(`BannerAd/${id}`);
  }

  public create(dto: BannerDto): Promise<number> {
    return this._apiService.post('BannerAds', dto);
  }

  public update(dto: BannerDto): Promise<void> {
    return this._apiService.put(`BannerAd/${dto.BannerId}`, dto);
  }

  public search(dto: BannerSearchDto): Promise<PagedResultGeneric<BannerDto>> {
    return this._apiService.post('BannerAds/Search', dto);
  }

  public delete(id: number): Promise<void> {
    return this._apiService.delete(`BannerAd/${id}`);
  }
}
